/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import headerConfig from "../config/header.config.json";
import loadingConfig from "../config/loading.config.json";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { VApplication } from "../../../application";
import { SignInPageService } from "..";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}
const getSrv1 = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.SignInPageService") as SignInPageService;
};
export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    const storageSrv = StorageModule.getInstance();
    const localStorage = storageSrv?.get("theme", "local");
    const brandLogo = localStorage?.bandLogo;
    console.log(brandLogo)
    let logoChanged = headerConfig;
    let loadingConfigchanged = loadingConfig;
    if (brandLogo) {
      logoChanged = {
        ...headerConfig,
        identifier: {
          ...headerConfig?.identifier,
          logo: brandLogo
        },
        password: {
          ...headerConfig?.password,
          logo: brandLogo
        },
        otp: {
          ...headerConfig?.otp,
          logo: brandLogo
        }
      };
      loadingConfigchanged = {
        ...loadingConfig,
        GetPageLoading: {
          ...loadingConfig?.GetPageLoading,
          image: brandLogo,
        },
        signInUser: {
          ...loadingConfig?.signInUser,
          image: brandLogo,
        }
      }
    }

    console.log(logoChanged)
    return {
      header: logoChanged,
      // header: headerConfig,
      loading: loadingConfigchanged,
    };
  }
}
// https://i.ibb.co/0sLwPKt/Tribe-Footer-removebg-preview.png